export { baseButtonPropDefs as buttonPropDefs } from './_internal/base-button.props.js';
